import moment from 'moment';
import { GAME_GATED_USER_AGE } from '../constants/prize';
import { Winning } from '../types/prize.types';

interface AccountInfo {
    dateOfBirth?: string;
}

export const isUserMeetingGameAgeRequirement = (
    accountInfo: AccountInfo | undefined,
    gameId: string
): boolean => {
    if (!accountInfo?.dateOfBirth) return true;

    const gateUserAge = GAME_GATED_USER_AGE[gameId] || 13;
    const dateOfBirth = moment(accountInfo.dateOfBirth);
    const today = moment();
    const age = today.diff(dateOfBirth, 'years', true);
    return age >= gateUserAge;
};

export const findFirstPrizeWithTaxInterviewUrl = (
    prizes: Winning[] | undefined,
    accountInfo: AccountInfo | undefined
): Winning | undefined => {
    if (!prizes || prizes.length === 0) return undefined;

    const firstPrizeMeetingAgeRequirement = prizes.find((winning) => {
        if (winning.taxInterviewUrl) {
            return isUserMeetingGameAgeRequirement(accountInfo, winning.gameId);
        }
        return false;
    });

    return firstPrizeMeetingAgeRequirement || prizes.find((winning) => winning.taxInterviewUrl);
};

export const isUserUnder18 = (accountInfo: AccountInfo | undefined): boolean => {
    if (!accountInfo?.dateOfBirth) return false;
    const dateOfBirth = moment(accountInfo.dateOfBirth);
    const today = moment();
    const age = today.diff(dateOfBirth, 'years', true);
    return age < 18;
};
